<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>メンバー管理</template>
      <template #right>
        <RouterLink
          :to="{
            name: 'memberManagementSettingNew',
            params: { entranceGUID: entranceGUID },
          }"
        >
          <FlatButton>新規作成</FlatButton>
        </RouterLink>
      </template>
    </SettingsPagePanelHeader>
    <ul v-if="result" :class="$style.list">
      <li
        v-for="staff in result.staffsByPlanner"
        :key="staff.guid"
        :class="$style.list__item"
      >
        <router-link
          :to="{
            name: 'memberManagementSettingDetail',
            params: {
              memberManagementSettingId: staff.guid,
              entranceGUID: entranceGUID,
            },
          }"
          :class="$style['listItem']"
        >
          <p v-if="staff.name">{{ staff.name }}</p>
          <p v-else>{{ staff.email }}</p>
          <div :class="$style.listItem__badge">
            <DolphinChip
              v-if="!!staff.connectedThirdPartyProvider"
              text="カレンダー連携済み"
              :class="[$style.extraChip, $style['extraChip--calendar']]"
            />
            <DolphinChip
              :text="roleName(staff.role)"
              :class="[$style.extraChip, $style['extraChip--none']]"
            />
          </div>
        </router-link>
      </li>
    </ul>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import DolphinChip from '@/components/atoms/DolphinChip.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useSettingsPageMemberManagementViewQuery } from './SettingsPageMemberManagementView.generated'
import type { StaffRole } from '@/types/schema.generated'
import { useRoute } from 'vue-router'

const route = useRoute('memberManagementSetting')

const entranceGUID = route.params.entranceGUID

const { result } = useSettingsPageMemberManagementViewQuery({
  fetchPolicy: 'no-cache',
})

const roleName = (staffRole: StaffRole): string => {
  switch (staffRole) {
    case 'MEMBER':
      return '一般'
    case 'ENTRANCE_MANAGER':
      return 'アカウント管理者'
    case 'BRANCH_MANAGER':
      return '支社管理者'
    case 'CORPORATION_ADMIN':
      return '企業管理者'
    default:
      return ''
  }
}
</script>

<style lang="scss" module>
.list {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:nth-child(n + 2) {
    margin-top: 12px;
  }

  &__item {
    border: 1px solid $color-border-low-emphasis;
    border-radius: $border-radius-v2-base;
    padding: 16px;

    &:hover {
      background-color: $color-surface-accent-primary-light;
    }
  }

  &__checkbox {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px;
    pointer-events: auto;
  }
}

.listItem {
  align-items: center;
  display: flex;
  justify-content: space-between;

  &__badge {
    display: flex;
    gap: 4px;
  }
}

.extraChip {
  font-weight: 700;
  color: $color-text-and-object-high-emphasis-inverse;

  &--none {
    background-color: $color-label-orange;
  }

  &--calendar {
    background-color: $color-label-water;
  }
}
</style>
